import { Navigate } from "react-router-dom";
import UserUtils from "../utils/UserUtils";
import navigate from "./navigate";

/**
 * FIXME as soon as each wrapped component is able to load its own state from a direct url call from the address bar.
 * Meanwhile this component will prevent errors from happening while trying to load a data from the backend for a
 * specific entity without having its ID.
 */
export const PreventDirectURLCall = ({ roles, children }) => {
  if (navigate.navigated) {
    return children;
  } else {
    return <Navigate to={roles ? UserUtils.getUserHome(roles) : "/"} />;
  }
};
